const dictionaries = {
  'dictionaries-breadcrumbs': 'Dictionaries',
  'dictionaries-filter-favorite-label': 'Favorite',
  'dictionaries-status-ready': 'Ready',
  'dictionaries-status-draft': 'Draft',
  'ui-dictionaries-create': 'Create dictionary',
  'ui-dictionaries-source-field': 'Source',
  'ui-dictionaries-version-field': 'Version',
  'ui-dictionaries-tags-field': 'Tags',
  'form-dictionaries-source-placeholder': 'Select a source',
  'form-dictionaries-structure-placeholder': 'Select a structure version',
  'form-dictionaries-structure-field': 'Structure version',
  'form-dictionaries-validation-field': 'Validation rules',
  'form-dictionaries-upgrade-field': 'Upgrade minor version to latest',
  'form-dictionaries-field-field': 'Field',
  'form-dictionaries-field-value-field': 'Field value',
  'form-dictionaries-field-placeholder': 'Select a field',
  'dictionaries-create-title': 'Create dictionary',
  'dictionaries-edit-title': 'Edit dictionary',
  'dictionaries-preview-structure-fields': 'Fields',
  'dictionaries-update-status-confirm-message': 'Are you sure you want to make the dictionary available for publication?',
  'dictionaries-update-status-confirm-message-danger': 'After confirming the action, all empty fields will be filled with values from the English language',
  'dictionaries-new-version-available': 'New minor version is available',
  'dictionaries-filter-title': 'Dictionaries filter',
  'translations-edit-button': 'Edit dictionary',
  'ui-dictionaries-status-ready': 'Mark as Ready',
  'dictionaries-missed-translations': 'No translations have been added yet.',
  'dictionaries-translation-preview': 'Preview dictionary translations',
  'dictionaries-export-template': 'Template export',
  'dictionaries-form-file-label': 'File',
  'form-dictionaries-version-placeholder': 'Select a version',
  'form-dictionaries-version-label': 'Version',
  'dictionaries-import-failed': 'Dictionaries import failed',
  'dictionaries-imported-list': 'Imported dictionaries',
  'dictionaries-structure-label': 'Structure',
  'dictionaries-import-success': 'Dictionaries imported successfully',
  'dictionaries-import-card-title': 'Import dictionaries',
  'dictionaries-import-page-failed': 'Oops! Something went wrong!',
  'dictionaries-empty-notification': 'Unable to view dictionary details, there is no created dictionary for current data',
  'dictionaries-delete-notification': 'Unable to delete dictionary because it is in use',
};

export default dictionaries;
